<script lang="ts">
	import type { RecipeType } from '$lib/types';
	import { ingredientToString } from '$lib/utils';

	export let recipe: RecipeType;
</script>

<div
	data-testid="rc-root"
	class="m-5 flex flex-col items-start justify-start gap-1 rounded-md border-2 border-solid border-accent bg-surface-100 p-5"
>
	{#if recipe?.title}
		<h1 class="py-2 text-xl font-medium text-surface-content/70">
			{recipe?.title}
		</h1>
	{/if}
	{#if recipe?.tags && recipe.tags.length > 0}
		<div class="flex flex-row gap-2">
			{#each recipe.tags as tag}
				<div class="rounded-md border-2 border-solid border-accent bg-secondary p-2">
					{tag.name}
				</div>
			{/each}
		</div>
	{/if}
	{#if recipe?.ingredients && recipe?.ingredients.length > 0}
		<div>
			<h3 class="py-2 text-lg font-medium text-surface-content/70">Ingredients</h3>
			<ul class="list-inside list-disc">
				{#each recipe?.ingredients as ingredient}
					<li class="text-surface-content/70">
						{ingredientToString(ingredient)}
					</li>
				{/each}
			</ul>
			{#if recipe?.additionalIngredients?.ingredients && recipe?.additionalIngredients?.title}
				<h3 class="py-2 text-lg font-medium text-surface-content/70">
					{recipe?.additionalIngredients.title}
				</h3>
				<ul class="list-inside list-disc">
					{#each recipe?.additionalIngredients.ingredients as ingredient}
						<li class="text-surface-content/70">
							{ingredientToString(ingredient)}
						</li>
					{/each}
				</ul>
			{/if}
		</div>
	{/if}
	{#if recipe?.instructions}
		<div>
			<h3 class="py-2 text-lg font-medium text-surface-content/70">Instructions</h3>
			<ol class="list-inside list-decimal">
				{#each Object.values(recipe?.instructions) as instruction}
					<li class="text-surface-content/70">
						{instruction.instruction}
					</li>
				{/each}
			</ol>
		</div>
	{/if}
	{#if recipe?.notes && recipe?.notes.length > 0}
		<div>
			<h3 class="py-2 text-lg font-medium text-surface-content/70">Notes</h3>
			<ul class="list-inside list-disc">
				{#each recipe?.notes as note}
					<li class="text-surface-content/70">
						{note}
					</li>
				{/each}
			</ul>
		</div>
	{/if}
</div>
